import React, {useEffect, useState} from 'react';
import {TextField, Button, Box, Alert, Typography, CircularProgress} from '@mui/material';
import {Link, useLocation, useNavigate} from "react-router-dom";
import {resetPassword} from "../services/api";

interface RegisterFormProps {
    success: boolean | null;
    loading: boolean | null;
    error: string | null;
    onSubmit: (data: { email: string; otp: string; newPassword: string }) => void;
    buttonText: string;
}

const ResetPasswordForm: React.FC<RegisterFormProps> = ({onSubmit, buttonText, loading, error, success}) => {
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailParam = params.get('email');
        const otpParam = params.get('otp');
        if (emailParam) setEmail(emailParam);
        if (otpParam) setOtp(otpParam);
    }, [location]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit({email, otp, newPassword});

    };
    if (success === true) {
        return (
            <Box component="form" onSubmit={handleSubmit} sx={{mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Typography component="h1" variant="h5" sx={{textAlign: 'center', mb: 3}}>
                    Пароль успешно установлен
                </Typography>
                <Link to="/login">Перейти к авторизации</Link>
            </Box>
        );
    }


    return (
        <Box>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                <Box component="form" onSubmit={handleSubmit} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Typography component="h1" variant="h5">
                        Ваш новый пароль
                    </Typography>

                </Box>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="otp"
                    label="Код подтверждения"
                    name="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="newPassword"
                    label="Новый пароль"
                    type="password"
                    id="newPassword"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
                {loading === true ?
                    <Box sx={{mt: 2, mb: 2, display: 'flex', justifyContent: 'center', height: 50}}>
                        <CircularProgress  style={{color: '#3a485b'}}/>
                    </Box>
                    :
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 2, mb: 1, height: 50}}
                    >
                        Применить
                    </Button>
                }

                <Box component="form" onSubmit={handleSubmit} sx={{mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <Link to="/login">Войти</Link>

                </Box>
            </Box>
        </Box>

    );
};

export default ResetPasswordForm;